import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useUiStore } from './stores/ui'
import $ from 'jquery'
import './style.css'

// Expose jQuery globally pour les anciens plugins (jquery-ui, round-slider)
// Ces plugins s'attachent à window.jQuery au moment de leur import
;(window as any).$ = $
;(window as any).jQuery = $

// Polyfills pour les APIs Node.js absentes du navigateur
if (typeof (window as any).setImmediate === 'undefined') {
  ;(window as any).setImmediate = (fn: TimerHandler, ...args: any[]) => setTimeout(fn, 0, ...args)
}
if (typeof (window as any).clearImmediate === 'undefined') {
  ;(window as any).clearImmediate = (id: number) => clearTimeout(id)
}

// Repère visuel : hors production, l'onglet du navigateur le dit. Évite de croire
// qu'on travaille sur les données clients alors qu'on est sur la base de test.
import { VZ_ENV } from './firebase'
if (VZ_ENV !== 'prod') {
  document.title = `[${VZ_ENV}] ${document.title}`
}

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)

// Applique le thème mémorisé (sombre par défaut) AVANT l'affichage,
// pour éviter un bref clignotement au chargement.
useUiStore(pinia).initTheme()

app.mount('#app')
